import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { ROUTE_DASHBOARD } from '../../config/routes';
import ACCOUNT_DRAWER_OPEN_EVENT, {
  ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY,
} from '../../config/events';

/** Must match MyAccount `DRAWER_TAB_NOTIFICATIONS` */
const NOTIFICATIONS_TAB_SESSION_VALUE = 'notifications';

/**
 * Iterable / Maestra often send mobile inbox deeplinks (`/notifications`,
 * `trashie://notifications`, `/account/notifications`). The web app has no
 * standalone screen — map them to account drawer → notifications tab.
 */
const NotificationsInboxWebRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    try {
      sessionStorage.setItem(
        ACCOUNT_DRAWER_NOTIFICATIONS_TAB_SESSION_KEY,
        NOTIFICATIONS_TAB_SESSION_VALUE,
      );
    } catch {
      /* ignore quota / private mode */
    }
    window.dispatchEvent(new Event(ACCOUNT_DRAWER_OPEN_EVENT));
    history.replace(ROUTE_DASHBOARD);
  }, [history]);

  return null;
};

export default NotificationsInboxWebRedirect;
